import React from "react";
import Navbar from "../../Components/Navbar";
import Header from "../../Components/Header";
import { Container, Typography } from "@mui/material";
import Footer from "../../Components/Footer";
import CallToEnroll from "../../Components/CallToEnroll";
import ActivitiesBanner from "../../assets/Activities.png";
import PageTitle from "../../Components/PageTitle";

const Activities = () => {
  return (
    <>
      <Navbar />
      <PageTitle
        title="Student Activities - Shree Mangalam School"
        description="Explore the wide range of extracurricular and co-curricular activities at Shree Mangalam School that help students build confidence, leadership, and team spirit."
        url="/activities"
        keywords="student activities, school events, co-curricular programs, Shree Manglam activities, RIMC preparation, personality development"
      />

      <Header image={ActivitiesBanner} alt={"Activities Banner image"} />

      <Container sx={{ mb: 5, mt: 5 }}>
        <Typography
          variant="h5"
          sx={{
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            fontSize: "30px",
            letterSpacing: 1,
            color: "#065A79",
            fontWeight: "bold",
          }}
          gutterBottom
        >
          Activities
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mt: 3,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          At Shree Mangalam School, we believe that true
          education happens when knowledge meets experience. That’s why our
          campus buzzes with activities that go beyond the traditional classroom
          and ignite a spirit of curiosity, creativity, and collaboration in
          every student.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Our co-curricular and extracurricular programs are thoughtfully
          designed to complement academic learning while fostering life skills,
          leadership, and emotional intelligence. We provide a nurturing
          environment where every child is encouraged to explore their interests
          and express their talents.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Here’s a glimpse of the vibrant activities we offer:
        </Typography>

        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            // fontSize: "30px",
            letterSpacing: 1,
            color: "#AD1C86",
            // fontWeight: "bold",
          }}
          gutterBottom
        >
          Cultural & Creative Arts
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          From music and dance to drama and storytelling, our cultural
          activities give students the stage to shine. Celebrating festivals,
          organizing annual functions, and participating in inter-school
          competitions instills pride, confidence, and cultural appreciation.
        </Typography>

        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            color: "#AD1C86",
          }}
          gutterBottom
        >
          Sports & Physical Development
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          We promote an active lifestyle through regular physical training, yoga
          sessions, inter-house games, and sports days. These activities help in
          building team spirit, discipline, and resilience, along with physical
          fitness.
        </Typography>
        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            // fontSize: "30px",
            letterSpacing: 1,
            color: "#AD1C86",
            // fontWeight: "bold",
          }}
          gutterBottom
        >
          Academic Enrichment
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Learning at our school is fun and engaging with quiz competitions,
          science exhibitions, math days, and language weeks. These events
          inspire a love for subjects and encourage critical thinking and
          problem-solving.
        </Typography>

        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            // fontSize: "30px",
            letterSpacing: 1,
            color: "#AD1C86",
            // fontWeight: "bold",
          }}
          gutterBottom
        >
          Leadership & Personality Development
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Through student councils, group discussions, debates, and public
          speaking events, we nurture leadership qualities and communication
          skills — preparing students to be confident individuals and future
          leaders.
        </Typography>

        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            // fontSize: "30px",
            letterSpacing: 1,
            color: "#AD1C86",
            // fontWeight: "bold",
          }}
          gutterBottom
        >
          Community & Environmental Initiatives
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          We involve students in plantation drives, cleanliness campaigns,
          charity events, and awareness rallies, helping them understand their
          role as responsible citizens who contribute positively to society and
          the planet.
        </Typography>

        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            // fontSize: "30px",
            letterSpacing: 1,
            color: "#AD1C86",
            // fontWeight: "bold",
          }}
          gutterBottom
        >
          Art, Craft & Innovation
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Creative sessions in painting, model making, DIY crafts, and
          innovation workshops unlock imagination and originality. Every project
          is an opportunity for students to showcase their ideas and build
          something meaningful.
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          At Shree Mangalam School, we don’t just teach — we
          inspire through every activity, every challenge, and every
          opportunity. Enroll now and let your child grow into a confident,
          capable, and compassionate individual.
        </Typography>
      </Container>
      <CallToEnroll />
      <Footer />
    </>
  );
};

export default Activities;
